<template>
  <div class="add-pay-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="680px"
      top="20px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-container class="flex just-center">
        <el-form
          ref="form"
          :model="params"
          :rules="rules"
          label-width="100px"
          label-position="right"
        >
<!--          <el-form-item label="签到类型:" prop="ctype">-->
<!--            <el-select v-model.number="params.ctype" placeholder="请选择签到类型" clearable>-->
<!--              <el-option :value="0" label="7天签到"></el-option>-->
<!--              <el-option :value="1" label="30天签到"></el-option>-->
<!--            </el-select>-->
<!--          </el-form-item>-->
          <el-form-item label="天数:" prop="day" v-if="params.ctype == 0">
            <el-select v-model.number="params.day" placeholder="请选择" clearable>
              <el-option :value="1" label="1天"></el-option>
              <el-option :value="2" label="2天"></el-option>
              <el-option :value="3" label="3天"></el-option>
              <el-option :value="4" label="4天"></el-option>
              <el-option :value="5" label="5天"></el-option>
              <el-option :value="6" label="6天"></el-option>
              <el-option :value="7" label="7天"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="任务类型：" prop="dtype">
            <el-select v-model.number="params.dtype" placeholder="请选择" @change="handleChangeType" clearable>
              <el-option :value="0" label="请选择"></el-option>
              <el-option  v-for="(item,index) in typeList" :key="index" :value="item.value" :label="item.label"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="数量信息：" prop="points" v-if="params.dtype>0">
            <span v-if="params.dtype==1">送 <el-input v-model.number="params.points" placeholder="请输入" style="width: 120px;" class="center-input"  maxlength="10" size="medium"></el-input> 积分</span>
            <span v-if="params.dtype==2">送 <el-input v-model.number="params.points" placeholder="请输入" style="width: 120px;" class="center-input"  maxlength="10" size="medium"></el-input> 张观影券</span>
            <span v-if="params.dtype==3">送 <el-input v-model.number="params.points" placeholder="请输入" style="width: 120px;" class="center-input"  maxlength="10" size="medium"></el-input> 天VIP</span>
            <span v-if="params.dtype==4">送 <el-input v-model.number="params.points" placeholder="请输入" style="width: 120px;" class="center-input"  maxlength="10" size="medium"></el-input> 个金币</span>
            <span v-if="params.dtype==5">随机送 [1~ <el-input v-model.number="params.points" placeholder="请输入" style="width: 120px;" class="center-input"  maxlength="10" size="medium"></el-input>] 天VIP</span>
            <span v-if="params.dtype==6">随机送 [1~ <el-input v-model.number="params.points" placeholder="请输入" style="width: 120px;" class="center-input"  maxlength="10" size="medium"></el-input>] 个金币</span>
            <span v-if="params.dtype==7">神秘大礼（上面6个随机送<el-input style="width: 60px;" v-model.number="params.points" placeholder="请输入" class="center-input" maxlength="10" size="medium"></el-input> 个）</span>
          </el-form-item>
          <el-form-item label="展示文案：" prop="extraReward" v-if="params.dtype>0">
            <el-input v-model="params.extraReward" placeholder="请输入" maxlength="30"  size="medium"></el-input>
          </el-form-item>
          <el-form-item label="排序：" prop="sorted">
            <el-input type="number" v-model.number="params.sorted" size="medium" placeholder="请输入" maxlength="10"></el-input>
          </el-form-item>
          <el-form-item label="是否启用：" prop="status" placeholder="请选择">
            <el-select v-model.number="params.status">
              <el-option
                  v-for="(item, idx) in statusList"
                  :label="item.label"
                  :value="item.value"
                  :key="idx"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="handleClose" size="small">取 消</el-button>
            <el-button
                type="primary"
                @click="submitForm('form')"
                :loading="flag"
                size="small"
            >确 认</el-button
            >
          </el-form-item>
        </el-form>
      </el-container>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api/checkRewards";
import {validatorIndex} from "@/utils/validator";

export default {
  data() {
    return {
      dialogVisible: false,
      labelPosition: "left",
      title: "",
      flag: false,
      id: "",
      type: "",
      statusList: [
        {label: '是', value: 1},
        {label: '否', value: 0},
      ],
      typeList:[
        {label:"送积分",value:1},
        {label:"送观影券",value:2},
        {label:"送VIP",value:3},
        {label:"送金币",value:4},
        {label:"随机送VIP",value:5},
        {label:"随机金币",value:6},
        {label:"神秘大礼",value:7},
      ],
      params: {
        id: "",
        day: 1,
        points:1 ,
        extraReward: "",
        dtype: 0,
        ctype: 1,
        sorted: 1,
        status: 0,
      },
      rules: {
        title: [{ required: true, message: "请输入名称", trigger: "blur" }],
        sort: [
          { required: true, message: "请输入排序", trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" },
        ],
        status: [
          { required: true, message: "请选择开关状态", trigger: "blur" },
        ],
      },
    };
  },

  watch:{
    "params.points": {
      handler(newVal) {
        this.params.points = newVal
        this.handleChangeType(this.params.dtype)
      },
      deep: true // 深度监听
    }
  },

  methods: {
    handleChangeType(e){
      if(e==1)this.params.extraReward = this.params.points+"积分";
      if(e==2)this.params.extraReward = this.params.points+"张观影券";
      if(e==3)this.params.extraReward = this.params.points+"天VIP";
      if(e==4)this.params.extraReward = this.params.points+"个金币";
      if(e==5)this.params.extraReward = this.typeList.find(c=>c.value == e).label;
      if(e==6)this.params.extraReward = this.typeList.find(c=>c.value == e).label;
      if(e==7)this.params.extraReward = this.typeList.find(c=>c.value == e).label;
    },
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          if (this.type === "add") {
            this.handleSave();
          } else {
            this.handleEdit();
          }
        } else {
          return false;
        }
      });
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        id: "",
        day: 1, //图片
        points:1 ,
        extraReward: "", //说明
        dtype: 0, //说明
        ctype: 1, //说明
        sorted: 1, //排序
        status: 0, //启用状态
      };
      this.$refs["form"].resetFields();
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, data) {
      this.type = type;
      this.dialogVisible = true;
      if (type === "edit") {
        this.title = "编辑签到";
        this.params.id = data.id;
        this.params.day = data.day;
        this.params.points = data.points;
        this.params.extraReward = data.extraReward;
        this.params.dtype = data.dtype;
        this.params.ctype = data.ctype || 1;
        this.params.sorted = data.sorted;
        this.params.status = data.status;
      } else {
        this.title = "新增签到";
        this.params = {
          id: "",
          day: 1, //图片
          points:1 ,
          extraReward: "", //说明
          dtype: 0, //说明
          ctype:1,
          sorted: data.sorted || 1, //排序
          status: 0, //启用状态
        }
      }
    },
    // 新增
    handleSave() {
      API.save(this.params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "添加成功",
              type: "success",
            });
            this.$emit("callback");
          } else {
            this.$message.error("添加失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    // 编辑
    handleEdit() {
      let form = Object.assign(this.params);
      API.update(form)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "编辑成功",
              type: "success",
            });
            this.$emit("callback");
          } else {
            this.$message.error("编辑失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
  },
};
</script>

<style lang="scss">
.add-pay-box {
  .el-input {
    width: 240px;
  }
  .form-flex-box {
    display: flex;
    .el-form-item {
      flex: 1;
    }
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border: 1px dashed #e63765;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>
